import { z } from "zod";

/**
 * ConfigureLoginForm
 */

export const ConfigureLoginFormSchema = z.object({
  loginAntigo: z.string().nonempty({
    message: "Este campo precisa ser preenchido!",
  }),
  oldPassword: z.string().nonempty({
    message: "Este campo precisa ser preenchido!",
  }),
  loginNovo: z.string().nonempty({
    message: "Este campo precisa ser preenchido!",
  }),
  newPassword: z.string().nonempty({
    message: "Este campo precisa ser preenchido!",
  }),
  newPasswordConf: z.string().nonempty({
    message: "Este campo precisa ser preenchido!",
  }),
}).superRefine((data, ctx) => {
  if (data.newPassword !== data.newPasswordConf) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['newPassword'],
      message: 'Senha e/ou confirmação de senha invalidos!'
    });

    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['newPasswordConf'],
      message: 'Senha e/ou confirmação de senha invalidos!'
    });
  }
});

export type ConfigureLoginForm = z.infer<typeof ConfigureLoginFormSchema>;